import type { Watch } from '@/views/MyWatchesView/MyWatchesView';

export const sortWatches = (watches: Watch[]) => {
  const orderedWatches = [...watches].sort((a, b) => {
    return new Date(b.end_date).getTime() - new Date(a.end_date).getTime();
  });
  return orderedWatches;
};
